module.exports = __webpack_public_path__ + "img/gallery-nft-03.e0fd916d.png";